module.exports = __webpack_public_path__ + "media/images/avaka-63a1e8860b95ebbb53c2bfc12a582e0f.png";